import {Component, OnInit, OnDestroy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {TermsService} from '../../services/terms.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-arbitrage-terms',
  templateUrl: './arbitrage-terms.component.html',
  styleUrls: ['./arbitrage-terms.component.scss']
})
export class ArbitrageTermsComponent implements OnInit, OnDestroy {
  termsText: string;
  private langSub: Subscription;

  constructor(
    private dialogRef: MatDialogRef<ArbitrageTermsComponent>,
    private termsService: TermsService,
    private translate: TranslateService
  ) {
    this.termsText = this.termsService.getTermsTextArbitrage();
  }

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.termsText = this.termsService.getTermsTextArbitrage();
    });
  }

  approve() {
    this.dialogRef.close({approve: true});
  }

  close() {
    this.dialogRef.close({approve: false});
  }

  ngOnDestroy(): void {
    if (this.langSub) { this.langSub.unsubscribe(); }
  }
}
